
const Index = () => import(/* webpackChunkName: "customer" */ "./index");
const StudentList = () => import(/* webpackChunkName: "customer" */ "./StudentList");
// const BalanceSheet = () => import(/* webpackChunkName: "customer" */ "./BalanceSheet");
// const NoInvoice = () => import(/* webpackChunkName: "customer" */ "./NoInvoice");

export default [
  {
    path: 'students',
    name: 'students',
    component: Index,
    redirect: { name: 'students-list' },
    children: [
      {
        path: 'list',
        name: 'students-list',
        component: StudentList,
      },
    ],
    
  },
]
